<div class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
  <div class="relative w-full max-w-md mx-4 transform transition-all duration-300 ease-out scale-100 opacity-100">
    <!-- Dialog Container -->
    <div class="bg-white rounded-2xl shadow-2xl overflow-hidden">
      <!-- Header -->
      <div class="bg-gradient-to-r from-red-500 to-red-600 px-6 py-4">
        <div class="flex items-center space-x-3">
          <div class="flex-shrink-0">
            <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
            </svg>
          </div>
          <div>
            <h3 class="text-lg font-semibold text-white">Confirmation de suppression</h3>
            <p class="text-red-100 text-sm">Cette action est irréversible</p>
          </div>
        </div>
      </div>

      <!-- Content -->
      <div class="px-6 py-6">
        <div class="mb-4">
          <p class="text-gray-700 text-base leading-relaxed">
            {{ data.msg || 'Êtes-vous sûr de vouloir supprimer cet élément ?' }}
          </p>
          <p class="text-gray-500 text-sm mt-2">
            Cette action ne peut pas être annulée et supprimera définitivement l'élément.
          </p>
        </div>

        <!-- Warning Icon -->
        <div class="flex items-center justify-center mb-6">
          <div class="bg-red-100 rounded-full p-4">
            <svg class="w-12 h-12 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
            </svg>
          </div>
        </div>
      </div>

      <!-- Actions -->
      <div class="bg-gray-50 px-6 py-4 flex space-x-3">
        <button 
          (click)="onCancel()"
          class="flex-1 px-4 py-2.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-colors duration-200"
        >
          Annuler
        </button>
        <button 
          (click)="onConfirm()"
          class="flex-1 px-4 py-2.5 text-sm font-medium text-white bg-red-600 border border-transparent rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors duration-200"
        >
          Supprimer
        </button>
      </div>
    </div>
  </div>
</div>     
